import React from 'react';
import PropTypes from 'prop-types';
import ConnectButton from '../../../pages/_banner/ConnectButton';
import Wrapper from '../../../pages/_banner/Wrapper';
import { DialogManager } from '../../../dialogs_new/DialogManager';
import useDialogLauncher from '../../_hooks/useDialogLauncher';

DeclineBanner.propTypes = {
  project: PropTypes.object.isRequired,
  question: PropTypes.object.isRequired
};

export default function DeclineBanner(props) {
  const { project, question, creator } = props;

  const launch = useDialogLauncher();
  const color = 'gray';

  function showConnectDialog() {
    launch(DialogManager.QuestionConnect.Config(question.id));
  }

  return (
    <Wrapper
      color={color}
      creator={creator}
      title={(
        <>
          Changed your mind? Let {creator.data.firstName} know!
        </>
      )}
      subtitle={(
        <>
          You previously said you couldn't collaborate. If things have changed, you can still
          connect and offer your support and collaboration now!
        </>
      )}
    >
      <div className="flex flex-col sm:flex-row space-x-0 space-y-4 sm:space-x-4 sm:space-y-0">
        <ConnectButton color={color} onClick={showConnectDialog}>
          I'd like to help
        </ConnectButton>
        {/*<ConnectButton color={color} onClick={() => history.push(`/project/${question.data.projectId}/messages`)}>*/}
        {/*  Go to messages*/}
        {/*</ConnectButton>*/}
      </div>
    </Wrapper>
  );
};
